/**
 * Strings added by the Settings fixes of 2026-10-28 (step-up with two-step,
 * notification permission, theme and language from the account, unsaved
 * profile changes, a missing microphone, device names, privacy switches
 * covered by Everyone).
 */
import type { Dict } from './core';

export const settingsEn: Dict = {
  // step-up for account actions
  'set.stepUp.password': 'Enter your password to continue.',
  'set.stepUp.code': 'Enter the code from your authenticator app to continue.',
  // notifications
  'set.notif.ask':
    "Your browser hasn't allowed notifications for this site yet, so none are shown.",
  'set.notif.allow': 'Allow notifications',
  'set.notif.notAllowed': "Notifications weren't allowed, so they stay off.",
  'set.notif.unsupported': "This browser can't show notifications.",
  // theme and language
  'set.look.notSaved':
    "Changed on this device, but it couldn't be saved to your account yet. It will be when you're connected again.",
  // unsaved changes
  'set.unsaved.title': 'Discard your changes?',
  'set.unsaved.body': "Your profile changes aren't saved yet.",
  'set.unsaved.discard': 'Discard',
  // voice
  'set.voice.releaseMs': '{n} ms',
  'set.voice.micMissing':
    "Your chosen microphone isn't connected, so the system default is used instead.",
  'set.voice.missingOption': 'Chosen microphone (not connected)',
  'set.voice.noMicFound': 'No microphone was found. Connect one and try again.',
  'set.voice.micFailed': "The microphone couldn't start. Another app may be using it.",
  // email
  'set.email.taken': 'Another account already uses this email.',
  // devices
  'set.device.on': '{browser} on {os}',
  // privacy
  'set.privacy.covered': 'Included in Everyone',
};
